
export default {
  data() {
    return {
      color: this.textColor ? `${this.textColor}--text` : "black--text"
    };
  },
  props: ["imageName", "bgColor", "title", "captions", "textColor"]
};
